function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "BG",
  width: 24,
  height: 24,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "color",
  d: "M4.053,17a1,1,0,0,1-.855-.48.966.966,0,0,1-.115-.716l1.136-4.975L.337,7.462a.972.972,0,0,1-.09-1.384A1,1,0,0,1,.9,5.748l5.143-.471L8.087.593a1,1,0,0,1,1.825,0l2.043,4.684,5.143.471a.989.989,0,0,1,.677.355.973.973,0,0,1-.112,1.359l-3.881,3.366L14.918,15.8a.965.965,0,0,1-.127.736.985.985,0,0,1-.624.437,1.009,1.009,0,0,1-.726-.113L9,14.259l-4.441,2.6A1,1,0,0,1,4.053,17ZM9,3.461,7.4,7.123l-4.022.368,3.035,2.632-.888,3.888L9,11.977H9l3.471,2.035-.887-3.888,3.033-2.632L10.6,7.123Z",
  transform: "translate(3 3)",
  fill: "#7e84a3"
});

function SvgStarOutlinedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "starOutlinedIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlinedIcon);
export default __webpack_public_path__ + "static/media/starOutlinedIcon.c06b545c.svg";
export { ForwardRef as ReactComponent };